import { ResolutionArrowDropdown } from "../../assets/svg/ResolutionArrowDropdown";
import { resolutionList, resolutionListT } from "../../utils/constants";
import s from "./ResolutionDropdown.module.scss";
import { FC, useState } from "react";

type ResolutionDropdownT = {
  resolution: resolutionListT;
  setResolution: (resolution: resolutionListT) => void;
};
export const ResolutionDropdown: FC<ResolutionDropdownT> = ({
  resolution,
  setResolution,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  function changeResolution(item: resolutionListT) {
    setResolution(item);
    setIsOpen(!isOpen);
  }
  return (
    <div
      className={`${s.resolution} ${isOpen && s.active}`}
      data-tour="rendering-area"
    >
      <div className={s.title} onClick={() => setIsOpen(!isOpen)}>
        <span>{`Rendering area: ${resolution.label}`}</span>
        <ResolutionArrowDropdown className={s.dropdown} />
      </div>
      <div className={s.content}>
        {resolutionList.map((item: resolutionListT, index: number) => {
          return (
            <div
              className={`${s.item} ${item.id === resolution.id && s.active}`}
              key={`resolution_${index}`}
              onClick={() => changeResolution(item)}
            >
              {`Rendering area: ${item.label}`}
            </div>
          );
        })}
      </div>
    </div>
  );
};
